import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-etd',
    templateUrl: './etd.component.html',
    styleUrls: ['./etd.component.scss']
})
export class EtdComponent implements OnInit {
    activeItemIndex = 0;
    items = [
        {
            title: 'Dashboard',
            icon: 'fa-settings',
            href: 'dashboard'
        },
        {
            title: 'My Thesis',
            icon: 'fa-settings',
            href: 'myThesis'
        },
        {
            title: 'Thesis catalog',
            icon: 'fa-settings',
            href: 'thesisCatalog'
        },
        {
            title: 'FAQ',
            icon: 'fa-settings',
            href: 'faq'
        }
    ];

    constructor(
        private _router: Router
    ) {
    }

    ngOnInit() {
        if (window.location.hash) {
            this.navigateByHash(window.location.hash);
        } else {
            this.onChangeTab(0);
        }
    }

    navigateByHash(hash) {
        this.activeItemIndex = this.items.findIndex(item => item.href === hash.split('#')[2]);
    }

    onChangeTab(index) {
        this.activeItemIndex = index;
        location.hash = `/etd#${this.items[this.activeItemIndex].href}`;
    }

}
